module.exports = __webpack_public_path__ + "img/MB.3b91408f.png";